import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from '../shared/services/webapi.service';
declare var $: any;  
 
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit{
  loader=false;
  videos:any=[];
  videoDetails:any="";
  constructor(public webApi: WebapiService,private toastrService: ToastrService) {}
  
  ngOnInit()  
  { 
    this.getVideos()
  }

  getVideos(){
    this.loader = true;
    this.webApi.getHomerecentvideos().subscribe((video: any) => {
      this.videos = [...this.videos,...video.videos]; 
      this.loader = false;
    });
  }

  getThumbUrl(url : string){
    return  url
  }

  

  addToFav(videoDetails:any) {  
    
    this.webApi.addVideoToFavourite(videoDetails.id).subscribe((data: any) => {
       if(data.success){
        videoDetails.fav=data.fav
        this.toastrService.success(data.message);
       }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }
  
  openDetails(id: Number,modalid:any){
    this.videoDetails = '';
    this.videoDetails = this.videos.filter(function(video:any) {
      return video.id == id;
    })[0]; 
    setTimeout(function(){
      $('#'+modalid).modal('show');
    }, 100);
  }
 
}
